import React from "react"
import Popup from "reactjs-popup"

const ConfirmationDialog = ({ title, message, isOpen, onConfirm, onCancel, onClose }) => (
	<Popup
		open={isOpen}
		onClose={onClose}
		modal
		nested
		contentStyle={{ width: "auto", border: "none", borderRadius: "10px", padding: "0" }}
		overlayStyle={{ background: "rgba(0, 0, 0, 0.5)" }}
	>
		<div className="bg-white p-6 rounded-xl shadow-md w-96 mx-auto">
			<div className="text-xl font-semibold mb-4 text-custom-blue">{title}</div>
			{/* Note message may contain PHI*/}
			<p className="mb-4 sensitive">{message}</p>
			<div className="flex justify-end">
				<button
					onClick={onCancel}
					className="mr-2 bg-gray-200 text-gray-800 px-4 py-2 rounded"
				>
					Cancel
				</button>
				<button onClick={onConfirm} className="bg-custom-blue text-white px-4 py-2 rounded">
					Confirm
				</button>
			</div>
		</div>
	</Popup>
)

export default ConfirmationDialog
